import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IsAdminGuard } from '../utils/guards/is-admin.guard';
import { IsAutenticateGuard } from '../utils/guards/is-autenticate.guard';
import { ErrorComponent } from './module-home/components/information/error/error.component';
import { TransactionStatusComponent } from './module-home/components/transactions/home/components/transaction-status/transaction-status.component';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { notFoundGuard } from './not-found.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import("./module-home/layaout.module").then(m => m.LayoutModule)
  },
  {
    path: 'auth',
    loadChildren: () => import("./module-auth/auth/auth.module").then(m => m.AuthModule)
  },
  {
    path: 'colaborador',
    canActivate: [IsAutenticateGuard],
    loadChildren: () => import("./module-admin/collaborator/collaborator.module").then(m => m.CollaboratorModule)
  },
  {
    path: 'admin',
    canActivate: [IsAutenticateGuard, IsAdminGuard],
    loadChildren: () => import("./module-admin/administrator/administrator.module").then(m => m.AdministratorModule)
  },
  { path: 'estado-transaccion/:id', component: TransactionStatusComponent },
  { path: 'not-found', component: NotFoundComponent },
  { path: '**', canActivate: [notFoundGuard], component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 120]
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
